import { Observable } from "rxjs";
import HttpService from "./HttpService"; 
import { url } from "./APIEndPoints";  
import { buildParamString, IAPICommonResponse, IAPIResponse } from "@mindmemobile/mm-shared-global";
import { IAPICreateBusinessModel, IAPICreateMerchantModel, IAPIUpdateApplicationStateModel } from "../interfaces/IAPICreateMerchantModel";
import { IAPICreateBussinessModel, IAPIDeleteMerchantAccount, IAPIMerchantAccountModel } from "../interfaces/IAPIMerchantModels";
import { IAPIMCCCodeResponseModel } from "../interfaces";

class MerchantAccountService {
  private httpService: HttpService;

  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );
  }

  createMerchantAccount(
    applicationData: IAPICreateMerchantModel
  ): Observable<IAPIResponse<any>> {
    return this.httpService.post<IAPIResponse<any>>(
      url.createMerchantAccount,
      applicationData
    );
  }

  createBusiness(
    applicationData: IAPICreateBusinessModel
  ): Observable<IAPIResponse<IAPICreateBussinessModel>> {
    return this.httpService.post<IAPIResponse<IAPICreateBussinessModel>>(
      url.createBusiness,
      applicationData
    );
  }

  getBusinesses(accountId: string): Observable<IAPIResponse<any>> {
    const apiUrl = `${url.getBusinesses}?accountId=${accountId}`;
    return this.httpService.get<IAPIResponse<any>>(apiUrl);
  }

  getMerchantAccounts(
    accountId: string,
    pageNumber: number,
    pageSize: number,
    searchValue: string
  ): Observable<IAPIResponse<IAPIMerchantAccountModel[]>> {
    const params: string = buildParamString({
      accountId: accountId,
      pageNumber: pageNumber,
      pageSize: pageSize,
      searchValue: searchValue,
    });

    return this.httpService.get<IAPIResponse<IAPIMerchantAccountModel[]>>(
      url.getMerchantAccounts,
      params
    );
  }

  getCompleteApplicationLink(
    accountId: string,
    applicationId: string
  ): Observable<IAPIResponse<any>> {
    const params: string = buildParamString({
      accountId: accountId,
      applicationId: applicationId,
    });

    return this.httpService.get<IAPIResponse<any>>(
      url.getCompleteApplicationLink,
      params
    );
  }

  getIsValidBusiness(
    accountId: string,
    businessName: string
  ): Observable<IAPIResponse<any>> {
    const params: string = buildParamString({
      accountId: accountId,
      businessName: businessName,
    });

    return this.httpService.get<IAPIResponse<any>>(
      url.getIsValidBusiness,
      params
    );
  }

  updateApplicationStatus(
    data: IAPIUpdateApplicationStateModel
  ): Observable<IAPIResponse<any>> {
    return this.httpService.put<IAPIResponse<any>>(
      url.updateMerchantApplicationStatus,
      data
    );
  }

  deleteMerchantAccount(
    data: IAPIDeleteMerchantAccount
  ): Observable<IAPIResponse<IAPICommonResponse>> {
    return this.httpService.delete<IAPIResponse<IAPICommonResponse>>(
      url.deleteMerchantAccount,
      data
    );
  }

  cancelMerchantAccount(
    data: IAPIDeleteMerchantAccount
  ): Observable<IAPIResponse<IAPICommonResponse>> {
    return this.httpService.put<IAPIResponse<IAPICommonResponse>>(
      url.cancelMerchantAccount,
      data
    );
  }

  getFiservMCCS(): Observable<
  IAPIResponse<IAPIMCCCodeResponseModel[]>
> {
  return this.httpService.get<IAPIResponse<IAPIMCCCodeResponseModel[]>>(
    url.getFiservMCCS,
    undefined
  );
}
}

export default new MerchantAccountService();
